<template>
    <div class='app-user'>
        <div class='user-header'>
            <img :src='userInfo.avatarPath'/>
            <div class='user-info'>
                <span class='user-name'>{{userInfo.realName}}</span>
                <span class='user-account'>账号：{{userInfo.account}}</span>
            </div>
        </div>
        <div class='user-item'>
            <div class='user-tip'>
                <span>手机号码</span>
                <span>{{userInfo.phone}}</span>
            </div>
            <div class='user-tip'>
                <span>角色</span>
                <span>{{userInfo.roleName}}</span>
            </div>
        </div>
        <div class='remove-account' @click='btn'>解除绑定</div>
        <Nav :navIndex='2'></Nav>
        <van-dialog v-model="show" show-cancel-button style='width:270px' @confirm='removeInfo'>
            <div class='title'>标题</div>
            <div class='make'>解除后将不会再收到新美云待办提醒，也不能再处理新美云待办事项</div>
        </van-dialog>
    </div>
</template>
<script>
import Nav from './appNav'
import * as Urls from '../../helper/Urls';
import * as VueHelper from '../../helper/VueHelper';
import {Dialog,Toast} from 'vant';
export default {
    data(){
        return{
            show:false,
            userInfo:{
                avatarPath:'https://xmyun.zhoty.com/resource/xmwebapp/user-portrait.png',
            }
        }
    },
    created(){
        this.userInfo = JSON.parse(sessionStorage.getItem('user'));
        if(!userInfo.wxOpenId){
            this.$router.push('/appLogin/agent')
        }
    },
    components:{
        Nav,Toast,[Dialog.Component.name]: Dialog.Component,
    },
    methods:{
        btn(){
            this.show = true;
        },
        removeInfo(){
            let inst = this;
            let url = Urls.wx_remove_info;
            inst.$root.doPost(url,{userId:this.userInfo.userId},function(server_data) {
                if( server_data.sessionExpire=='Y'){
                    return;
                }
                // 应用错误
                if(server_data.error){
                    Toast(server_data.error);
                    return;
                };
                sessionStorage.clear()
                inst.$router.push('/appLogin/agent')
            },null,1)
            
        }
    }
}
</script>
<style lang="scss" scoped>
.app-user{
    height: calc(100vh);
    background:#eee;
    max-width: 750px;
    font-family: PingFang SC;
    .user-header{
        height: 1rem;
        background:#fff;
        padding:0 .15rem;
        display: flex;
        align-items: center;
        margin-bottom: .1rem;
        img{
            width: .6rem;
            height: .6rem;
            border-radius: 50%;
            margin-right: .15rem;
        }
        .user-info{
            display: flex;
            flex-direction: column;
            .user-name{
                font-size: 0.21rem;
                font-weight: bold;
                color:#000;
                height: .2rem;
                line-height: .2rem;
                margin-bottom: .12rem;
            }
            .user-account{
                height: 0.14rem;
                font-size: 0.14rem;
                color:#999;
                line-height: .14rem;
            }
        }
    }
    .user-item{
        padding:0 .15rem;
        background:#fff;
        .user-tip{
            height: .58rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span{
                font-size: .18rem;
                color:#000;
                &:first-child{
                    color: #999;
                }
            }
            &:first-child{
                    border-bottom: .01rem solid #EBEBEB;
            }
        }
    }
    .remove-account{
        height: .57rem;
        background:#fff;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top:.1rem;
        font-size: 0.18rem;
        color:#999;
    }
}
.make{
        padding: 0 .3rem;
        font-size: 0.14rem;
        color:#999;
        line-height: .18rem;
        margin-bottom: .16rem;
    }
    .title{
        font-size: .18rem;
        font-weight: bold;
        color:#000;
        height: .18rem;
        line-height: .18rem;
        margin:.18rem 0 .08rem;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// appUserInfo.vue?1b3c671f